import { Placement } from "@blueprintjs/core";
import React, { ReactNode } from "react";
import styled from "styled-components";

import { HexKeyCombo, HexTooltip } from "../../hex-components";

export interface HotkeyHelperTooltipProps {
  className?: string;
  hotkeyName: string;
  combo: string;
  children: ReactNode;
  placement?: Placement;
  disabled?: boolean;
  hoverOpenDelay?: number;
}

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const HotkeyHelperTooltip: React.FunctionComponent<
  HotkeyHelperTooltipProps
> = ({
  children,
  className,
  combo,
  disabled = false,
  hotkeyName,
  hoverOpenDelay = 500,
  placement = "bottom",
}) => {
  return (
    <HexTooltip
      className={className}
      content={
        <ContentWrapper>
          <span css="flex: none; margin-right: 6px;">{hotkeyName}</span>
          <HexKeyCombo combo={combo}></HexKeyCombo>
        </ContentWrapper>
      }
      disabled={disabled}
      hoverOpenDelay={hoverOpenDelay}
      interactionKind="hover"
      placement={placement}
    >
      {children}
    </HexTooltip>
  );
};
